
import { AlertTriangle } from 'lucide-react';

interface BuildVersionIndicatorProps {
  buildVersion: string;
}

export const BuildVersionIndicator = ({ buildVersion }: BuildVersionIndicatorProps) => {
  return (
    <div className="p-2 bg-blue-50 border border-blue-200 rounded text-xs text-blue-700">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-3 w-3" />
        <span>Build: {buildVersion.split('T')[0]} {buildVersion.split('T')[1]?.split('.')[0]}</span>
      </div>
    </div>
  );
};
